var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.294V7.706h-1.711a4.477 4.477 0 00-4.436-3.912H7.659a3.353 3.353 0 100 1.118h6.194a3.358 3.358 0 013.306 2.794h-2.747v2.235H7.706a3.918 3.918 0 00-3.877 3.394 3.353 3.353 0 103.831 3.871h5.962l-.723.723.79.79 2.072-2.072-2.072-2.072-.79.79.722.722H7.659a3.362 3.362 0 00-2.7-2.739 2.8 2.8 0 012.748-2.29h6.706v2.235zM4.353 6.588a2.235 2.235 0 112.235-2.235 2.238 2.238 0 01-2.235 2.235zm2.235 10.059a2.235 2.235 0 11-2.235-2.235 2.238 2.238 0 012.235 2.235zm8.941-7.824h3.353v3.353h-3.353z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#a1ff00",
    strokeWidth: 2.5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 3.25
  }))));
}
export default SvgTask;